module.exports = __webpack_public_path__ + "static/media/Amit.0b3b2747.png";